import React from "react";
import { Chart, ChartCanvas } from "@react-financial-charts/core";
import { XAxis, YAxis } from "@react-financial-charts/axes";
import { macd } from "@react-financial-charts/indicators";
import { discontinuousTimeScaleProviderBuilder } from "@react-financial-charts/scales";
import { MACDSeries } from "@react-financial-charts/series";
import BuyChart from "../../../pages/BuyChart";
import { format } from "d3-format";
import { nFormatter } from "../../../utils/utils";

const PVOIndicator = ({
  height,
  ratio,
  width,
  chartData,
  xAccessor,
  displayXAccessor,
  xScale,
  xExtents,
}) => {
  // console.log(chartData, "chartData");
  const formattedChartData = chartData.map((item) => ({
    ...item,
    date: new Date(item.timestamp),
  }));

  const macdAppearance = {
    fillStyle: {
      divergence: "#4d98ba",
    },
    strokeStyle: {
      macd: "#f95e6b",
      signal: "#201f20",
      zero: "rgba(0, 0, 0, 0.3)",
    },
  };

  const xScaleProvider =
    discontinuousTimeScaleProviderBuilder().inputDateAccessor((d) => d.date);

  const macdCalculator = macd()
    .options({
      fast: 12,
      signal: 9,
      slow: 26,
    })
    .merge((d) => {
      // console.log(d, "dddddddddv");
      d.macd = {
        macd: d.PVO,
        signal: d.PVOs,
        divergence: d.PVOh,
      };
    })
    .accessor((d) => d.macd);

  const calculatedData = macdCalculator(formattedChartData);

  const { data } = xScaleProvider(calculatedData);

  const yAccessor = macdCalculator.accessor();
  const options = macdCalculator.options();

  const calculateOptimalTicks = (data, chartHeight) => {
    const dataRange =
      Math.max(...data.map((item) => item.PVO)) -
      Math.min(...data.map((item) => item.PVO));
    let baseTickNumber = Math.floor(chartHeight / 50);
    const rangeAdjustment = Math.ceil(dataRange / 10);
    const finalTickNumber = baseTickNumber + rangeAdjustment;
    return Math.max(finalTickNumber, 3);
  };
  const optimalTicks = calculateOptimalTicks(calculatedData, height);

  return (
    <ChartCanvas
      height={height}
      ratio={ratio}
      width={width}
      disableZoom={true}
      disablePan={true}
      disableInteraction={true}
      data={data}
      displayXAccessor={displayXAccessor}
      seriesName="Data"
      xScale={xScale}
      xAccessor={xAccessor}
      xExtents={xExtents}
    >
      <Chart id={1} yExtents={yAccessor}>
        <XAxis strokeStyle={"#8d8d8d"} tickStrokeStyle={"#8d8d8d"} />
        {/* <YAxis tickFormat={format(".2f")} ticks={5} /> */}
        <YAxis
          strokeStyle={"#8d8d8d"}
          tickStrokeStyle={"#8d8d8d"}
          tickFormat={format(".2f")}
          ticks={optimalTicks}
        />
        <XAxis
          strokeStyle={"#8d8d8d"}
          tickStrokeStyle={"#8d8d8d"}
          showTicks={false}
          xZoomHeight={1}
          tickPadding={0}
          axisAt={"top"}
          orient={"top"}
        />
        <YAxis
          strokeStyle={"#8d8d8d"}
          tickStrokeStyle={"#8d8d8d"}
          showTicks={false}
          yZoomWidth={1}
          tickPadding={0}
          axisAt={"left"}
          orient={"left"}
        />

        <MACDSeries yAccessor={yAccessor} {...macdAppearance} />

        {/*<MACDTooltip*/}
        {/*  origin={[8, 16]}*/}
        {/*  appearance={macdAppearance}*/}
        {/*  options={options}*/}
        {/*  yAccessor={yAccessor}*/}
        {/*/>*/}
      </Chart>
    </ChartCanvas>
  );
};

export default PVOIndicator;
